import BasePlatformNumbersAccordion from './BasePlatformNumbersAccordion';
import { useState } from 'react';
const StandardSection = ({
    errors,
    touched,
    submitData,
    setSubmitData,
    platformTrunks,
    platformID,
    isLocationDisabled,
    platformLocations,
    selectedTrunk,
    setSelectedTrunk,
    section = '',
}) => {
    const trunkList = Array.isArray(platformTrunks) ? platformTrunks : [];
    const trunkCount = trunkList.length;
    const isTrunkDisabled = trunkCount <= 0; // Default is - Not Allocated -
    const locationList = Array.isArray(platformLocations)
        ? platformLocations
        : [];
    const locationCount = locationList.length;
    const [isChecked, setIsChecked] = useState(
        !!submitData?.find((platform) => platform?.platformID === platformID)
            ?.trunkID || false,
    );
    const fields = [
        BasePlatformNumbersAccordion({
            errors: errors,
            touched: touched,
            submitData: submitData,
            setSubmitData: setSubmitData,
            platformTrunks: platformTrunks,
            platformID: platformID,
            trunkList: trunkList,
            trunkCount: trunkCount,
            isTrunkDisabled: isTrunkDisabled,
            section: section,
            isChecked: isChecked,
            setIsChecked: setIsChecked,
            isLocationDisabled: isLocationDisabled,
            platformLocations: platformLocations,
            locationList: locationList,
            locationCount: locationCount,
            selectedTrunk: selectedTrunk,
            setSelectedTrunk: setSelectedTrunk,
        }),
    ];

    return fields;
};

export default StandardSection;
